import APIClient from '@/shared/http/clients/api'

const resourceName = 'threec/calls'
const APICore = process.env.APIBaseURLCore

class ThreeCCallsRepository {
  async getAllCalls (pageable = {}) {
    const params = {
      page: pageable.page || 0,
      size: pageable.size || 10,
      sort: pageable.sort || 'createdAt,desc'
    }

    const url = `${APICore}/${resourceName}`

    return APIClient.get(url, { params })
  }

  async saveCall (callData) {
    const url = `${APICore}/${resourceName}`

    return APIClient.post(url, callData)
  }
}

export default new ThreeCCallsRepository()



// WEBPACK FOOTER //
// ./src/shared/http/repositories/threec/calls.js